export default __webpack_public_path__ + "static/media/agri-dev1.5a302aa5.jpg";